define('order_wizard_promocodenotifications.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('order_wizard_promocodenotifications', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return " ";
},"useData":true}, 'extensions/Tavanoteam/TT_Theme_MedicinalGenomics/1.0.13/', 'extensions/Tavanoteam/TT_Theme_MedicinalGenomics/1.0.13/', Handlebars);
});